import { createContext, useState, useEffect } from "react";
import { getPCPChangesPatients } from "../../../utils/services/APP/PCPChanges/getPCPChangesPatients";
import { getPCPChangesByCip } from "../../../utils/services/APP/PCPChanges/getPCPChangesByCip";
import { useValidToken } from "../../../hooks/useValidToken";

export const PCPChangesContext = createContext();

export const PCPChangesProvider = ({ children }) => {
  const [PCPChangesPatients, setPCPChangesPatients] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [detailsLoading, setDetailsLoading] = useState(false);

  const [selectedCip, setSelectedCip] = useState(null);
  const [PCPChangesDetails, setPCPChangesDetails] = useState([]);

  const [page, setPage] = useState(0); // 0-based for MUI DataGrid
  const [pageSize, setPageSize] = useState(50);

  const { isValid, authLoading } = useValidToken();

  const fetchSummary = async () => {
    setLoading(true);
    try {
      const res = await getPCPChangesPatients(page + 1, pageSize); // API espera 1-based
      setPCPChangesPatients(res.data.map((item) => ({ ...item, id: item.cipId })));
      setTotal(res.total);
    } catch (error) {
      console.error('[PCPChangesContext] Error loading summary:', error);
    }
    setLoading(false);
  };

  const fetchPCPChangesDetails = async (cipId) => {
    setDetailsLoading(true);
    try {
      const res = await getPCPChangesByCip(cipId);
      setPCPChangesDetails(res);
      setSelectedCip(cipId);
    } catch (error) {
      console.error("Error loading care gaps for CIP:", cipId, error);
    }
    setDetailsLoading(false);
  };

  useEffect(() => {
    if (!isValid || authLoading) return;
    fetchSummary();
  }, [page, pageSize, authLoading, isValid]);

  return (
    <PCPChangesContext.Provider
      value={{
        PCPChangesPatients,
        total,
        page,
        pageSize,
        loading,
        detailsLoading,
        PCPChangesDetails,
        selectedCip,
        setPage,
        setPageSize,
        fetchPCPChangesDetails,
        setSelectedCip
      }}
    >
      {children}
    </PCPChangesContext.Provider>
  );
};
